import { Grid, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { Props } from "./interfaces";
import { DateContainer } from "./styles";
import { listOfMonths } from "../../utils/time-utils";

const StyledDate = ({ date, month, year, customColor }: Props) => {
  const { t } = useTranslation();
  return (
    <>
      <DateContainer customColor={customColor}>
        <Typography variant="h5">{date}</Typography>
        <Grid>
          <Typography variant="body2">{`${t(listOfMonths[month])}`}</Typography>
          <Typography variant="body2">{year}</Typography>
        </Grid>
      </DateContainer>
    </>
  );
};

export default StyledDate;
